// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__g1sh-","control":"Checkout_control__GVg5i","actions":"Checkout_actions__7B4wj","submit":"Checkout_submit__nxoli","invalid":"Checkout_invalid__VQBNb"};